// extracted by mini-css-extract-plugin
export var ctaLink = "CtaButton-module--ctaLink--a3c00";